var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"pa-1",staticStyle:{"position":"relative","min-height":"100%","max-width":"1450px","margin":"0 0"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }